import { setTerm } from './helpers';

export const setListingType = setTerm('newbuilding_results_type');
